let isEnabled = false;

export function isRebrandingEnabled(): boolean {
  return isEnabled;
}

export function setRebrandingEnabled(value: boolean): void {
  isEnabled = value;
}
